import { api } from '@/services/api'
import { latticeApi } from '@/services/latticeApi'
import { chatApi } from '@/services/chatApi'
import { contractorDashboardApi } from '@/services/contractorDashboardApi'
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import eventQueueReducer from '../store/slices/eventQueueSlice'
import commentReducer from '../store/slices/commentSlice'
import userReducer from '../store/slices/userSlice'
import trueRoleReducer from '../store/slices/trueRoleSlice'
import productLocator from '../store/slices/productLocatorSlice'
import scheduleChecksGenerator from '../store/slices/scheduleChecksGeneratorSlice'
import websocketReducer, { websocketService } from '../services/websocketService'
import { listenerMiddleware } from '../store/middleware/commentMiddleware'
import { websocketMiddleware } from '../store/middleware/websocketMiddleware'
import threadReducer from '../store/slices/threadSlice'
import displayTypeReducer from '../store/slices/displayTypeSlice'
import pageReducer from '../store/slices/latticePageSlice'
import pdfEditReducer from '../store/slices/pdfEditSlice'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [latticeApi.reducerPath]: latticeApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [contractorDashboardApi.reducerPath]: contractorDashboardApi.reducer,
    eventQueue: eventQueueReducer,
    comment: commentReducer,
    user: userReducer,
    trueRole: trueRoleReducer,
    productLocations: productLocator,
    scheduleChecks: scheduleChecksGenerator,
    websocket: websocketReducer,
    thread: threadReducer,
    displayType: displayTypeReducer,
    page: pageReducer,
    pdfEdit: pdfEditReducer,
  },

  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .prepend(websocketMiddleware.middleware)
      .concat(api.middleware)
      .concat(latticeApi.middleware)
      .concat(chatApi.middleware)
      .concat(contractorDashboardApi.middleware),
})

websocketService.init(store.dispatch, store.getState);

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
